

///////////////////////
// Extend JavaScript //
///////////////////////

// https://www.javatpoint.com/javascript-sleep
// const sleep = seconds => new Promise(resolve => setTimeout(resolve, seconds * 1000))


/***********/
/* NUMBERS */
/***********/

const FLOAT_EPSILON = .0099999999999

Number.prototype.equalTo = function (b) {
  return Math.abs(this.valueOf() - b) < FLOAT_EPSILON
}

Number.prototype.notEqualTo = function (b) {
  return ! this.equalTo(b)
}

Number.prototype.greaterThan = function (b) {
  return (this.valueOf() - b) > FLOAT_EPSILON
}

Number.prototype.greaterThanOrEqualTo = function (b) {
  return this.greaterThan(b) || this.equalTo(b)
}

Number.prototype.lessThan = function (b) {
  return (b - this.valueOf()) > FLOAT_EPSILON
}

Number.prototype.lessThanOrEqualTo = function (b) {
  return this.lessThan(b) || this.equalTo(b)
}

// https://www.delftstack.com/howto/javascript/javascript-round-to-2-decimal-places/
Number.prototype.roundTo = function (precision) {
  return + (Math.round(this.valueOf() + `e+${precision}`) + `e-${precision}`)
}
Math.roundToCurrency = v => Number(v).roundTo(2)


/***********/
/* STRINGS */
/***********/

// https://stackoverflow.com/questions/610406/javascript-equivalent-to-printf-string-format
String.prototype.formatUnicorn = function (...args) {
  let str = this.toString()
  for (let i = 0; i < args.length; i++) {
    str = str.replace('%@', args[i])
  }
  return str
}

String.prototype.versionize = function (limit = 3) {
  const versions = this.toString().split('.', limit).map(Number)

  return limit === 1 ? versions[0] : versions
}

// https://attacomsian.com/blog/javascript-generate-random-string
String.randomChar = () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62))
String.random = (length = 8) => {
  let str = ''
  for (let i = 0; i < length; i++) {
    str += String.randomChar()
  }
  return str
}

// copied from xef-back app/Helpers/Helpers@withoutDiacritic
String.prototype.withoutDiacritic = function () {
  let str = this.toString()
  const a = ['À', 'Á', 'Â', 'Ã', 'Ä', 'Å', 'Æ', 'Ç', 'È', 'É', 'Ê', 'Ë', 'Ì', 'Í', 'Î', 'Ï', 'Ð', 'Ñ', 'Ò', 'Ó', 'Ô', 'Õ', 'Ö', 'Ø', 'Ù', 'Ú', 'Û', 'Ü', 'Ý', 'ß', 'à', 'á', 'â', 'ã', 'ä', 'å', 'æ', 'ç', 'è', 'é', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó', 'ô', 'õ', 'ö', 'ø', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ', 'Ā', 'ā', 'Ă', 'ă', 'Ą', 'ą', 'Ć', 'ć', 'Ĉ', 'ĉ', 'Ċ', 'ċ', 'Č', 'č', 'Ď', 'ď', 'Đ', 'đ', 'Ē', 'ē', 'Ĕ', 'ĕ', 'Ė', 'ė', 'Ę', 'ę', 'Ě', 'ě', 'Ĝ', 'ĝ', 'Ğ', 'ğ', 'Ġ', 'ġ', 'Ģ', 'ģ', 'Ĥ', 'ĥ', 'Ħ', 'ħ', 'Ĩ', 'ĩ', 'Ī', 'ī', 'Ĭ', 'ĭ', 'Į', 'į', 'İ', 'ı', 'Ĳ', 'ĳ', 'Ĵ', 'ĵ', 'Ķ', 'ķ', 'Ĺ', 'ĺ', 'Ļ', 'ļ', 'Ľ', 'ľ', 'Ŀ', 'ŀ', 'Ł', 'ł', 'Ń', 'ń', 'Ņ', 'ņ', 'Ň', 'ň', 'ŉ', 'Ō', 'ō', 'Ŏ', 'ŏ', 'Ő', 'ő', 'Œ', 'œ', 'Ŕ', 'ŕ', 'Ŗ', 'ŗ', 'Ř', 'ř', 'Ś', 'ś', 'Ŝ', 'ŝ', 'Ş', 'ş', 'Š', 'š', 'Ţ', 'ţ', 'Ť', 'ť', 'Ŧ', 'ŧ', 'Ũ', 'ũ', 'Ū', 'ū', 'Ŭ', 'ŭ', 'Ů', 'ů', 'Ű', 'ű', 'Ų', 'ų', 'Ŵ', 'ŵ', 'Ŷ', 'ŷ', 'Ÿ', 'Ź', 'ź', 'Ż', 'ż', 'Ž', 'ž', 'ſ', 'ƒ', 'Ơ', 'ơ', 'Ư', 'ư', 'Ǎ', 'ǎ', 'Ǐ', 'ǐ', 'Ǒ', 'ǒ', 'Ǔ', 'ǔ', 'Ǖ', 'ǖ', 'Ǘ', 'ǘ', 'Ǚ', 'ǚ', 'Ǜ', 'ǜ', 'Ǻ', 'ǻ', 'Ǽ', 'ǽ', 'Ǿ', 'ǿ', 'Ά', 'ά', 'Έ', 'έ', 'Ό', 'ό', 'Ώ', 'ώ', 'Ί', 'ί', 'ϊ', 'ΐ', 'Ύ', 'ύ', 'ϋ', 'ΰ', 'Ή', 'ή']
  const b = ['A', 'A', 'A', 'A', 'A', 'A', 'AE', 'C', 'E', 'E', 'E', 'E', 'I', 'I', 'I', 'I', 'D', 'N', 'O', 'O', 'O', 'O', 'O', 'O', 'U', 'U', 'U', 'U', 'Y', 's', 'a', 'a', 'a', 'a', 'a', 'a', 'ae', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y', 'A', 'a', 'A', 'a', 'A', 'a', 'C', 'c', 'C', 'c', 'C', 'c', 'C', 'c', 'D', 'd', 'D', 'd', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'G', 'g', 'G', 'g', 'G', 'g', 'G', 'g', 'H', 'h', 'H', 'h', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'I', 'i', 'IJ', 'ij', 'J', 'j', 'K', 'k', 'L', 'l', 'L', 'l', 'L', 'l', 'L', 'l', 'l', 'l', 'N', 'n', 'N', 'n', 'N', 'n', 'n', 'O', 'o', 'O', 'o', 'O', 'o', 'OE', 'oe', 'R', 'r', 'R', 'r', 'R', 'r', 'S', 's', 'S', 's', 'S', 's', 'S', 's', 'T', 't', 'T', 't', 'T', 't', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'W', 'w', 'Y', 'y', 'Y', 'Z', 'z', 'Z', 'z', 'Z', 'z', 's', 'f', 'O', 'o', 'U', 'u', 'A', 'a', 'I', 'i', 'O', 'o', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'A', 'a', 'AE', 'ae', 'O', 'o', 'Α', 'α', 'Ε', 'ε', 'Ο', 'ο', 'Ω', 'ω', 'Ι', 'ι', 'ι', 'ι', 'Υ', 'υ', 'υ', 'υ', 'Η', 'η']
  for (let i = a.length - 1; i >= 0; i--) {
    str = str.replaceAll(a[i], b[i])
  }
  return str
}

const crc8Table = new Uint8Array([
  0x00, 0x07, 0x0e, 0x09, 0x1c, 0x1b, 0x12, 0x15,
  0x38, 0x3f, 0x36, 0x31, 0x24, 0x23, 0x2a, 0x2d,
  0x70, 0x77, 0x7e, 0x79, 0x6c, 0x6b, 0x62, 0x65,
  0x48, 0x4f, 0x46, 0x41, 0x54, 0x53, 0x5a, 0x5d,
  0xe0, 0xe7, 0xee, 0xe9, 0xfc, 0xfb, 0xf2, 0xf5,
  0xd8, 0xdf, 0xd6, 0xd1, 0xc4, 0xc3, 0xca, 0xcd,
  0x90, 0x97, 0x9e, 0x99, 0x8c, 0x8b, 0x82, 0x85,
  0xa8, 0xaf, 0xa6, 0xa1, 0xb4, 0xb3, 0xba, 0xbd,
  0xc7, 0xc0, 0xc9, 0xce, 0xdb, 0xdc, 0xd5, 0xd2,
  0xff, 0xf8, 0xf1, 0xf6, 0xe3, 0xe4, 0xed, 0xea,
  0xb7, 0xb0, 0xb9, 0xbe, 0xab, 0xac, 0xa5, 0xa2,
  0x8f, 0x88, 0x81, 0x86, 0x93, 0x94, 0x9d, 0x9a,
  0x27, 0x20, 0x29, 0x2e, 0x3b, 0x3c, 0x35, 0x32,
  0x1f, 0x18, 0x11, 0x16, 0x03, 0x04, 0x0d, 0x0a,
  0x57, 0x50, 0x59, 0x5e, 0x4b, 0x4c, 0x45, 0x42,
  0x6f, 0x68, 0x61, 0x66, 0x73, 0x74, 0x7d, 0x7a,
  0x89, 0x8e, 0x87, 0x80, 0x95, 0x92, 0x9b, 0x9c,
  0xb1, 0xb6, 0xbf, 0xb8, 0xad, 0xaa, 0xa3, 0xa4,
  0xf9, 0xfe, 0xf7, 0xf0, 0xe5, 0xe2, 0xeb, 0xec,
  0xc1, 0xc6, 0xcf, 0xc8, 0xdd, 0xda, 0xd3, 0xd4,
  0x69, 0x6e, 0x67, 0x60, 0x75, 0x72, 0x7b, 0x7c,
  0x51, 0x56, 0x5f, 0x58, 0x4d, 0x4a, 0x43, 0x44,
  0x19, 0x1e, 0x17, 0x10, 0x05, 0x02, 0x0b, 0x0c,
  0x21, 0x26, 0x2f, 0x28, 0x3d, 0x3a, 0x33, 0x34,
  0x4e, 0x49, 0x40, 0x47, 0x52, 0x55, 0x5c, 0x5b,
  0x76, 0x71, 0x78, 0x7f, 0x6a, 0x6d, 0x64, 0x63,
  0x3e, 0x39, 0x30, 0x37, 0x22, 0x25, 0x2c, 0x2b,
  0x06, 0x01, 0x08, 0x0f, 0x1a, 0x1d, 0x14, 0x13,
  0xae, 0xa9, 0xa0, 0xa7, 0xb2, 0xb5, 0xbc, 0xbb,
  0x96, 0x91, 0x98, 0x9f, 0x8a, 0x8d, 0x84, 0x83,
  0xde, 0xd9, 0xd0, 0xd7, 0xc2, 0xc5, 0xcc, 0xcb,
  0xe6, 0xe1, 0xe8, 0xef, 0xfa, 0xfd, 0xf4, 0xf3,
])

String.prototype.crc8 = function () {
  return this.toString()
    .split('')
    .map(x => x.charCodeAt(0)) // => byteArray
    .reduce((acc, current) => crc8Table[(acc ^ current) % 0xff], 0x00)
}

/**********/
/* ARRAYS */
/**********/

Array.prototype.sortBy = function (prop) {
  return this.sort((a, b) => a[prop] > b[prop] ? 1 : -1)
}

Array.prototype.sortByNumber = function (prop) {
  return this.sort((a, b) => a[prop] - b[prop])
}

Array.prototype.sortByString = function (prop) {
  return this.sort((a, b) => a[prop].localeCompare(b[prop]))
}

Array.prototype.sortByNatural = function (prop) {
  return this.sort((a, b) => a[prop].localeCompare(b[prop], undefined, { numeric: true, sensitivity: 'base' }))
}

Array.prototype.last = function () {
  return this[this.length - 1]
}

Array.prototype.pluck = function (prop) {
  return this.map(o => o[prop])
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
Array.prototype.sum = function (prop) {
  return this.reduce((acc, current) => acc + (prop ? current[prop] ?? 0 : current), 0)
}

// https://www.robinwieruch.de/javascript-groupby
Array.prototype.groupBy = function (prop) {
  return this.reduce((acc, current) => {
    if (! acc[current[prop]]) {
      acc[current[prop]] = []
    }
    acc[current[prop]].push(current)
    return acc
  }, {})
}

// https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
Array.prototype.unique = function () {
  return [...new Set(this)]
}

// https://stackoverflow.com/questions/6229197/how-to-know-if-two-arrays-have-the-same-values
Array.prototype.contains = function (other) {
  return other.every(item => this.includes(item))
}

Array.prototype.isEqual = function (other, sameOrder = false) {
  if (! Array.isArray(other)) {
    throw new Error('Parameter is not an Array')
  }
  if (this.length !== other.length) {
    return false
  }
  return sameOrder
    ? this.toString() === other.toString()
    : this.contains(other) && other.contains(this)
}

Array.prototype.isExactly = function (other) {
  return this.isEqual(other, true)
}

// https://medium.com/@amirdanish126/how-to-count-duplicate-value-in-an-array-in-javascript-e942b59af8f2
Array.prototype.countElements = function () {
  const r = {}
  this.forEach(x => {
    r[x] = (r[x] || 0) + 1
  })
  return r
}

/***********/
/* OBJECTS */
/***********/

Object.isObject = function (v) {
  return typeof v === 'object'
      && v !== null
      && ! Array.isArray(v)
}
